var exports = {
  "oq": "LexicalSearchInput.module__editorShell___YlZlOW",
  "LL": "LexicalSearchInput.module__editable___YlZlOW",
  "FY": "LexicalSearchInput.module__paragraph___YlZlOW",
  "bI": "LexicalSearchInput.module__tokenBase___YlZlOW",
  "bV": "LexicalSearchInput.module__tokenKey___YlZlOW",
  "vA": "LexicalSearchInput.module__tokenValue___YlZlOW",
  "eT": "LexicalSearchInput.module__tokenUnapplied___YlZlOW",
  "GU": "LexicalSearchInput.module__tokenExclude___YlZlOW",
  "qf": "LexicalSearchInput.module__placeholder___YlZlOW",
};

module.exports = exports;
